import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { repiActions } from '../../../store/repiStore';
import { hasPermission } from '../../../store/apiWrapper';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import Invoices from './invoices/invoices';
import RequestingHistory from './paymentHistory/requestingHistory';
import RepiContractsHistory from './paymentHistory/repiContractsHistory';
import RepiContractsSummary from './paymentHistory/repiContractsSummary';

import '../repi.scss';

class PaymentHistory extends React.Component {
    render() {
        const { data } = this.props;
        const isContracts = (!isNullOrUndefined(data) && !isNullOrUndefined(data.paymentHistory) && !isNullOrUndefined(data.paymentHistory.detail) && !isNullOrUndefined(data.paymentHistory.detail.contracts) &&  data.paymentHistory.detail.contracts.length > 0);

        if (isNullOrUndefined(data))
            return null;

        return (
            <div className="repi-payment-history-container">
                {(!this.props.isDataCorrection() && isContracts) && <RepiContractsSummary data={data} />}
                {isContracts && <RepiContractsHistory data={data} />}
                {(hasPermission(null, "REPIITrade") && !isNullOrUndefined(data.paymentHistory.detail.iTrade)
                    && data.paymentHistory.detail.iTrade.availability.isAvailable) && <Invoices sections={true} data={data.paymentHistory.detail.iTrade} />}
                <RequestingHistory data={data} />
            </div>
        );
    }
}

export default connect(
    state => state.report,
    dispatch => bindActionCreators(repiActions, dispatch)
)(withLocalize(withRouter(PaymentHistory)));
